import Grid from '@mui/material/Grid';
import { makeStyles } from 'tss-react/mui';
import { endCall } from '../../../store/dialer';
import { useAppDispatch } from '../../../store/hooks';
import StyledIconButtonRejectCall from '../StyledIconButtonRejectCall/StyledIconButtonRejectCall';
import ActiveCallDialPad from './ActiveCallDialPad';
import ActiveCallMuteIcon from './ActiveCallMuteIcon';

const useStyles = makeStyles()({
    buttonWrapperPrimary: {
        '& .MuiIconButton-root': {
            padding: '6px',
        },
    },
});

export default function ActiveCallControls() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    //const handleAcceptCall = () => {
    //    dispatch(twilioActions.acceptCall());
    //}

    const handleEndCall = () => {
        dispatch(endCall());
    };

    return (
        <Grid container direction="row" wrap="nowrap" alignItems="center" spacing={1}>
            <Grid item xs="auto" className={classes.buttonWrapperPrimary}>
                <ActiveCallDialPad />
            </Grid>
            <Grid item xs="auto" className={classes.buttonWrapperPrimary}>
                <ActiveCallMuteIcon />
            </Grid>
            <Grid item xs="auto" className={classes.buttonWrapperPrimary}>
                <StyledIconButtonRejectCall onClick={handleEndCall} />
            </Grid>
        </Grid>
    );
}
